import React, { useState, useEffect } from 'react';
import { Modal, Button, Table, Spinner } from 'react-bootstrap';
import { getPropertyJobs } from '../service/JobService';

export default function PropertyJobsModal({ show, handleClose, property }) {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (show && property) {
      loadPropertyJobs();
    }
  }, [show, property]);

  const loadPropertyJobs = async () => {
    setLoading(true);
    setError(null);
    
    try {
      // Get jobs from 2 months ago to 2 months in the future
      const currentDate = new Date();
      const startDate = new Date(currentDate);
      startDate.setMonth(currentDate.getMonth() - 2);
      
      const endDate = new Date(currentDate);
      endDate.setMonth(currentDate.getMonth() + 2);
      
      const response = await getPropertyJobs(property.property_id, startDate, endDate);
      
      if (response.status === 200) {
        const data = await response.json();
        setJobs(data);
      } else {
        setError('Failed to load jobs');
      }
    } catch (err) {
      setError('Error loading jobs: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Jobs for {property?.full_address} (±2 months)</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center my-4">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : error ? (
          <div className="alert alert-danger">{error}</div>
        ) : jobs.length === 0 ? (
          <div className="alert alert-info">No jobs found for this property in the ±2 month period.</div>
        ) : (
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Job ID</th>
                <th>Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {jobs.map((job) => (
                <tr key={job.job_id}>
                  <td>
                    <a 
                      href={`/manage-job/update-job/${job.cos_job_id}`} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {job.cos_job_id}
                    </a>
                  </td>
                  <td>{formatDate(job.date)}</td>
                  <td>{job.status}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
